import { useMutation } from "@/compat/reactQuery";
import actionService from "../../services/actionService";

const useSaveAction = () => useMutation(actionService.update, {});

export default useSaveAction;
